module.exports = __webpack_public_path__ + "static/social-9050a13705d30e573c4837c2e17b5049.png";